/*jshint esversion: 8 */
import store from '../components/stores/Store';
import { fetchPost } from './RequestHandler';


// 查询房票
const getTickets = async (d) => {
  const rst = await fetchPost('/web_ticket/getTickets', { data: d });
  return rst;
};


// 增加房票
const addTicket = async (data) => {
  const rst = await fetchPost('/web_ticket/addTicket', { data });
  return rst;
};


// 修改房票
const updateTicket = async (data) => {
  const rst = await fetchPost('/web_ticket/updateTicket', { data });
  return rst;
};

// 删除房票
const deleteTicket = async (data) => {
  const rst = await fetchPost('/web_ticket/deleteTicket', { data });
  return rst;
};

// 审核
const verifyTicket = async (data) => {
  const rst = await fetchPost('/web_ticket/verifyTicket', { data });
  return rst;
};

// 反审
const unverifyTicket = async (data) => {
  const rst = await fetchPost('/web_ticket/unverifyTicket', { data });
  return rst;
};

// 获取附件
const getImageUrls = async (data) => {
  const rst = await fetchPost('/web_ticket/getImageUrls', { data });
  return rst;
};


// 删除图片
const deleteImage = async (data) => {
  const rst = await fetchPost('/web_ticket/deleteImage', { data });
  return rst;
};




export {
  addTicket,
  getTickets,
  updateTicket,
  deleteTicket,
  verifyTicket,
  unverifyTicket,

  getImageUrls,
  deleteImage,
};
